import React, { FC } from 'react';
import styles from './Input.module.scss';

interface Props {
  error?: string,
}
const Error: FC<Props> = ({ error }) => <div className={styles.error}>{error}</div>;

export default Error;
